import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

/**
 * Dashboard Admin - Prêt pour les KPI
 * Cette page sera remplie avec des KPI et statistiques plus tard
 */
const AdminDashboard = () => {
  const { t } = useLanguage();

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Tableau de bord Admin</h1>
        <p className="text-gray-500 mt-1">Bienvenue sur votre espace d'administration</p>
      </div>

      {/* Placeholder pour les KPI */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-12 text-center">
        <div className="max-w-md mx-auto">
          <div className="w-16 h-16 bg-[#27489E]/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-[#27489E]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Dashboard en préparation
          </h3>
          <p className="text-gray-500">
            Les KPI et statistiques seront ajoutés prochainement.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
